export const endpoints = {
  /** Auth */
  getMealMeStore: (id) => `/meal-me/menu/store/${id}`,
  getMealMeStoresList: () => `/meal-me/menu/stores`,
  getMealMeMenuDownload: () => `/meal-me/menu/download`,
  emailVerify: () => `/meal-me/menu/send/verification-email`,
  generateCount: () => `/meal-me/menu/generated-count`,
};
